import React from "react";
import ChessBoard from "./Component/Chessboard/ChessBoard";
import "./App.css";

function App() {
  return (
    <div className="app">
      <ChessBoard />
    </div>
  );
}

export default App;
